import React, { useEffect, useRef, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import { imageUrl } from "../../Constants/contant";
import { scroller } from "react-scroll";
import { useLocation, useNavigate } from "react-router-dom";

const CategoryOne = ({categories,onCategoryClick}) => {
  const swiperRef = useRef(null);
  const [isSticky, setIsSticky] = useState(false);

  
  const navigate = useNavigate();
  const location = useLocation();

    useEffect(() => {
      if (location.state?.scrollTo) {
        const section = location.state.scrollTo;
        setTimeout(() => {
          scroller.scrollTo(section, {
            smooth: true,
            duration: 600,
            offset: -80,
          });
        }, 400);
      }
    }, [location]);
  
    
    const handleScrollClick = (section) => {
      if (location.pathname === "/") {
        scroller.scrollTo(section, {
          smooth: true,
          duration: 600,
          offset: -80,
        });
      } else {
        navigate("/", { state: { scrollTo: section } });
      }
    };
  
    // ✅ Sticky header logic
    useEffect(() => {
      const handleScroll = () => setIsSticky(window.scrollY > 500);
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }, []);


  useEffect(() => {
    if (!swiperRef.current) return;

    const swiperInstance = swiperRef.current.swiper;

    // ✅ Start autoplay properly
    if (swiperInstance && swiperInstance.autoplay) {
      swiperInstance.autoplay.start();
    }
    // ✅ Custom pagination with numbers
    if (swiperInstance.pagination) {
      swiperInstance.pagination.renderBullet = function (index, className) {
        let formattedNumber = index + 1 < 10 ? "0" + (index + 1) : index + 1;
        return `<span class="${className} number">${formattedNumber}</span>`;
      };
      swiperInstance.pagination.init();
      swiperInstance.pagination.update();
    }
    
    const multiplier = {
      translate: 0.1,
      rotate: 0.01,
    };

    const calculateWheel = () => {
      const slides = document.querySelectorAll(".single");
      slides.forEach((slide) => {
        const rect = slide.getBoundingClientRect();
        const r = window.innerWidth * 0.5 - (rect.x + rect.width * 0.5);
        let ty = Math.abs(r) * multiplier.translate - rect.width * multiplier.translate;

        if (ty < 0) {
          ty = 0;
        }
        const transformOrigin = r < 0 ? "left top" : "right top";
        slide.style.transform = `translate(0, ${ty}px) rotate(${-r * multiplier.rotate}deg)`;
        slide.style.transformOrigin = transformOrigin;
      });
    };

    const raf = () => {
      requestAnimationFrame(raf);
      calculateWheel();
    };

    raf();

    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    <section id="service"
      className="category-area bg-top-center"
      style={{ backgroundImage: "url(/assets/img/bg/tour1.jpg)", backgroundRepeat: "no-repeat" }}
    >
      <div className="container th-container">
        <div className="title-area text-center">
          {/* <span className="sub-title">Wonderful Place For You</span> */}
          <h2 className="sec-title">Our Services</h2>
        </div>

        <Swiper
          ref={swiperRef}
          modules={[Pagination, Autoplay]}
          slidesPerView={1}
          breakpoints={{
            576: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
            1200: { slidesPerView: 3 },
            1400: { slidesPerView: 5 },
          }}
          spaceBetween={40}
          loop={true}
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          speed={1000}
          pagination={{
            clickable: true,
            el: ".swiper-pagination",
            type: "bullets"
          }} // ✅ Defined renderBullet inside pagination
          className="th-slider has-shadow categorySlider"
        >
          {categories?.map((category) => (
            <SwiperSlide key={category.id}>
              <div className="category-card single" onClick={() => onCategoryClick(category)}
>
                <div className="box-img global-img">
                  <img src={imageUrl + category.image} alt={category.title} loading="lazy" />
                </div>
                <h3 className="box-title">
                    <button
                          onClick={() => handleScrollClick(category.id)}
                          style={{
                            background: "none",
                            border: "none",
                            color: "black",
                            cursor: "pointer",
                          }}
                        >
                          {category.name}
                        </button>
                </h3>
               
              </div>
            </SwiperSlide>
          ))}
          <div className="slider-controller w-100 justify-content-center">
            <div className="swiper-pagination" style={{maxWidth:"100%"}}></div>
          </div>
        </Swiper>

      </div>
    </section>
  );
};

export default CategoryOne;
